import React from 'react';

import { BREAKPOINTS, unit, white } from '@zego/theme';

import RegularText from '@zego/components/atoms/RegularText';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import ContentContainer from '@zego/components/ContentContainer';
import Logo from '@zego/components/header/Logo';

const LogoSection = ({ logo, logoAlt, logoTop, logoHeight }) => (
  <ContentContainer
    css={{
      zIndex: 1000,
      position: 'relative',
      marginBottom: unit(3),
      paddingTop: unit(3),
      [BREAKPOINTS.normal]: {
        paddingTop: 36,
      },
    }}
  >
    <View
      css={{
        flexGrow: 0,
        display: 'flex',
        alignItems: 'center',
        fill: white,
      }}
    >
      <Logo />
      <Spacer width={unit(2)} />
      <RegularText css={{ fontSize: 32, color: white, opacity: 0.8 }}>
        |
      </RegularText>
      <Spacer width={unit(2)} />
      <img
        alt={logoAlt}
        css={{
          display: 'inline-block',
          position: 'relative',
          top: logoTop,
          height: logoHeight,
        }}
        src={logo}
      />
    </View>
  </ContentContainer>
);

export default LogoSection;
